export const genUIComponentNotSupportedStyles = {
  root: "my-2 rounded-lg border border-border bg-secondary px-3 py-2 text-xs text-muted-foreground",
  code: "font-mono text-mid",
};
